import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LanguageService } from './language.service';

const ACCEPT_LANGUAGE_HEADER = 'Accept-Language';

/**
 * Functional HTTP interceptor that stamps every outgoing request with an
 * `Accept-Language` header sourced from {@link LanguageService.getCurrentLanguage}.
 *
 * The backend's per-request language resolver reads this header to decide
 * which language to project translatable entity fields to.
 *
 * If the caller has already set an explicit `Accept-Language` header (e.g.
 * for a one-off override), this interceptor leaves it untouched.
 */
export const languageHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(ACCEPT_LANGUAGE_HEADER)) return next(req);
  const language = inject(LanguageService).getCurrentLanguage();
  return next(req.clone({ headers: req.headers.set(ACCEPT_LANGUAGE_HEADER, language) }));
};
